import PropTypes from 'prop-types';
import React, { Component } from 'react';

import UploadPhoto from './uploadPhoto';
import ColorPicker from './colorPicker';
import Avatar from './avatar';


export default class UploadAvatar extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    who: PropTypes.string.isRequired,
    color: PropTypes.string,
  }
  static defaultProps = {
    color: '',
  }

  render() {
    const { color, name, who } = this.props;

    return (
      <div className="c-wrapper">
        <UploadPhoto name={name} className="c-avatar-upload">
          {imageUrl => <Avatar who={who} imageUrl={imageUrl} alt="" />}
        </UploadPhoto>
        <ColorPicker name={color} display-if={color} />
      </div>
    );
  }
}
